// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"e6ae902f","555":"d6bbcac1","748":"eb9b8b84"}[chunkId] + ".chunk.css";
};